import track from './eventTracker';

const SearchResultsTracker = new (function () {
  this.trackPDPViewEvent = ({ skuId, source, queryId, externalProductId }) => {
    return track({
      event_name: 'search_results.interaction',
      canonical_name: 'pdp',
      action_type: 'view',
      action_name: 'pdp_view',
      sku_id: skuId,
      external_product_id: externalProductId,
      source,
      query_id: queryId,
    });
  };
})();

export default SearchResultsTracker;
